// src/services/gatePassService.ts
import api from "../lib/api.ts";

interface TicketPaginationParams {
  page?: number;
  limit?: number;
  orderBy?: string;
  order?: "ASC" | "DESC";
}
interface TicketCreationParams {
  subject: string;
}

export const getPaginatedTickets = async (params: TicketPaginationParams) => {
  const response = await api.get("/tickets/paginated", { params });
  return response.data;
};

export const createTicketBuyer = async (params: TicketCreationParams) => {
  const response = await api.post("/tickets/create/buyer", { ...params });
  return response.data;
};

export const createTicketSeller = async (params: TicketCreationParams) => {
  const response = await api.post("/tickets/create/seller", { ...params });
  return response.data;
};
